<template>
  <div class="ll-display-export-card-list">
    <p class="ll-display-export-card-list_title">
      {{ $t(title) }}
    </p>
    <div class="ll-display-export-card-list_content">
      <LlEmptyPic
        v-if="cardItems.length === 0 && !isloading"
        :image="require('@/assets/image/img-empty/Blue-file-empty.png')"
        :title="emptyText"
      />
      <LlDisplayExportCard
        v-for="(item,itemIndex) in cardItems"
        :key="itemIndex"
        :title="item.title"
        :system-subclasses="item.systemSubclasses"
        :type="item.type"
        :date="item.date"
        :update-at="item.updateAt"
        :date-title="dateTitle"
        :tags="item.factoryTags"
        @click="onClick(item.id)"
        @pdf-click="exportPdfClick()"
        @excel-click="exportExcelClick()"
      />
    </div>
    <DotLoading v-if="isloading" />
  </div>
</template>
<script>
export default {
  name: "LlDisplayExportCardList",
  props: {
    title: {
      type: String,
      default: "",
    },
    cardItems: {
      type: Array,
      default() {
        return [];
      },
    },
    isloading: {
      type: Boolean,
      default: false,
    },
    emptyText: {
      type: String,
      default() {
        return this.$t("目前沒有相關法規變更");
      },
    },
    dateTitle: {
      type: String,
      default: "",
    },
  },
  methods: {
    exportPdfClick() {
      this.$emit("pdf-click");
    },
    exportExcelClick() {
      this.$emit("excel-click");
    },
    onClick($event) {
      this.$emit("click", $event);
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/ll-display-export-card-list";
</style>